<div class="container">
  <h1 class="main-title">Access Denied</h1>
  <h4 class="subtitle">You do not have access to view this site. Please try logging in again or contacting your site
    administrator.</h4>

  <button class="em-c-btn" (click)="goToLogin()">
    <span class="em-c-btn__text">Back to Login Screen</span>
  </button>
</div>